export const fleebeAppUrl = import.meta.env.VITE_APP_API_URL ?? "";
import courseNoImage from "@/assets/images/goals/no_image.svg";
export const imageDefaultForCourses = courseNoImage;
